// Meoks: Bedenimi Bul wizard
(function () {
  var STORAGE_KEY = 'meoks_sf_user_data_v1';
  var SF_I18N = (window.MeoksI18n && window.MeoksI18n.sizeFinder) || {};
  function sft(key, vars) {
    var str = SF_I18N[key] || key;
    if (vars) { for (var k in vars) { str = str.split('__' + k + '__').join(vars[k]); } }
    return str;
  }

  function load() { try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}'); } catch (e) { return {}; } }
  function save(d) { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(d)); } catch (e) {} }
  function clear() { try { localStorage.removeItem(STORAGE_KEY); } catch (e) {} }

  function calcRecommendation(modal, data) {
    var defaultChart = [];
    var productGuide = null;
    var variantMeas = [];
    try { defaultChart = JSON.parse(modal.getAttribute('data-default-chart') || '[]'); } catch (e) {}
    try {
      var pg = modal.getAttribute('data-product-guide');
      if (pg) productGuide = JSON.parse(pg);
    } catch (e) {}
    try { variantMeas = JSON.parse(modal.getAttribute('data-variant-measurements') || '[]'); } catch (e) {}
    var sizeValues = (modal.getAttribute('data-size-values') || '').split(',').filter(Boolean);

    // 0) Variant ölçüleri dolu mu? Etiketlere göre hangi ölçü = göğüs/bel/kalça tespit et
    var olcuLabels = [];
    try { olcuLabels = JSON.parse(modal.getAttribute('data-olcu-labels') || '[]'); } catch (e) {}
    function findIdxFor(keywords) {
      for (var i = 0; i < olcuLabels.length; i++) {
        var lbl = (olcuLabels[i] || '').toLowerCase();
        for (var k = 0; k < keywords.length; k++) {
          if (lbl.indexOf(keywords[k]) !== -1) return i;
        }
      }
      return -1;
    }
    var chestIdx = findIdxFor(['göğüs', 'gogus', 'chest', 'bust']);
    var waistIdx = findIdxFor(['bel', 'waist']);
    var hipIdx = findIdxFor(['kalça', 'kalca', 'hip', 'kalca cevr']);
    var allowance = 4;
    if (data.fit === 'cok-dar') allowance = 0;
    else if (data.fit === 'dar') allowance = 2;
    else if (data.fit === 'bol') allowance = 8;
    else if (data.fit === 'cok-bol') allowance = 12;

    // Kullanıcının girdiği ölçüleri topla (dinamik olcu_1, olcu_2, ...)
    var userOlculer = [];
    for (var i = 1; i <= 6; i++) {
      var v = data['olcu_' + i];
      if (v && v > 0) userOlculer[i - 1] = v;
    }
    var hasAnyOlcu = userOlculer.length > 0 && userOlculer.some(function (x) { return x > 0; });

    if (variantMeas && variantMeas.length > 0 && hasAnyOlcu) {
      var bestV = null;
      var bestScore = Infinity;
      variantMeas.forEach(function (vm) {
        if (!vm.values || vm.values.length === 0) return;
        var totalScore = 0;
        var matched = 0;
        olcuLabels.forEach(function (lbl, idx) {
          var userVal = userOlculer[idx];
          if (!userVal) return;
          var garmentVal = vm.values[idx] || 0;
          if (garmentVal <= 0) return;
          var lblLow = (lbl || '').toLowerCase();
          // Genişlik/yarım çevre etiketleri → garmentı ×2
          if (lblLow.indexOf('genişlik') !== -1 || lblLow.indexOf('genislik') !== -1 || lblLow.indexOf('width') !== -1) {
            garmentVal = garmentVal * 2;
          }
          var target = userVal + allowance;
          var diff = garmentVal - target;
          totalScore += diff >= 0 ? diff : -diff * 2;
          matched++;
        });
        if (matched > 0 && totalScore < bestScore) { bestScore = totalScore; bestV = vm; }
      });
      if (bestV) return bestV.size;
    }

    // 1) Detaylı ölçü öncelikli (göğüs/bel/kalça varsa ve productGuide cm bazlı)
    if (productGuide && Array.isArray(productGuide) && (data.gogus || data.bel || data.kalca)) {
      var best = null, bestScore = -1;
      productGuide.forEach(function (row) {
        var score = 0;
        if (data.gogus && row.gogus_min != null && data.gogus >= row.gogus_min && data.gogus <= row.gogus_max) score += 3;
        if (data.bel && row.bel_min != null && data.bel >= row.bel_min && data.bel <= row.bel_max) score += 3;
        if (data.kalca && row.kalca_min != null && data.kalca >= row.kalca_min && data.kalca <= row.kalca_max) score += 2;
        if (score > bestScore) { bestScore = score; best = row; }
      });
      if (best && bestScore > 0) return applyFit(best.size, data.fit, productGuide.map(function (r) { return r.size; }));
    }

    // 2) Boy + Kilo
    var chart = (productGuide && productGuide[0] && productGuide[0].height_min != null) ? productGuide : defaultChart;
    var b = null, bs = -1;
    chart.forEach(function (row) {
      var s = 0;
      if (data.height && row.height_min != null && data.height >= row.height_min && data.height <= row.height_max) s += 2;
      if (data.weight && row.weight_min != null && data.weight >= row.weight_min && data.weight <= row.weight_max) s += 3;
      if (s > bs) { bs = s; b = row; }
    });
    if (!b) return sizeValues.length ? sizeValues[Math.floor(sizeValues.length/2)] : 'M';
    var allSizes = chart.map(function (r) { return r.size; });
    return applyFit(b.size, data.fit, allSizes);
  }

  function applyFit(size, fit, sizes) {
    var idx = sizes.indexOf(size);
    if (idx === -1) return size;
    var shift = 0;
    if (fit === 'cok-dar') shift = -2;
    else if (fit === 'dar') shift = -1;
    else if (fit === 'bol') shift = 1;
    else if (fit === 'cok-bol') shift = 2;
    var newIdx = Math.max(0, Math.min(sizes.length - 1, idx + shift));
    return sizes[newIdx];
  }

  function getTotalSteps(modal) {
    return modal.querySelectorAll('.meoks-sf-step').length;
  }
  function findStepNumbers(modal) {
    return Array.from(modal.querySelectorAll('.meoks-sf-step')).map(function (s) { return parseInt(s.getAttribute('data-step'), 10); });
  }

  function setStep(modal, stepNum) {
    var steps = modal.querySelectorAll('.meoks-sf-step');
    var titles = SF_I18N.stepTitles || { 1: 'Temel bilgiler', 2: 'Silüetinizin şekli', 3: 'Ölçüleriniz', 4: 'Kesim tercihi', 5: 'Bedeniniz' };
    var stepArr = findStepNumbers(modal);
    var maxStep = Math.max.apply(null, stepArr);
    steps.forEach(function (s) {
      var n = parseInt(s.getAttribute('data-step'), 10);
      s.classList.toggle('is-active', n === stepNum);
    });
    var titleEl = modal.querySelector('[data-sf-title]');
    if (titleEl) titleEl.textContent = titles[stepNum] || '';
    var backBtn = modal.querySelector('[data-meoks-sf-back]');
    if (backBtn) backBtn.hidden = stepNum === 1 || stepNum === maxStep;
    var nextBtn = modal.querySelector('[data-sf-next]');
    var editBtn = modal.querySelector('[data-sf-edit]');
    var clearBtn = modal.querySelector('[data-sf-clear]');
    var legal = modal.querySelector('[data-sf-legal]');
    var addCartBtn = modal.querySelector('[data-sf-addcart]');
    if (stepNum === maxStep) {
      nextBtn.hidden = true;
      editBtn.hidden = false;
      clearBtn.hidden = false;
      if (addCartBtn) addCartBtn.hidden = false;
      if (legal) legal.hidden = true;
    } else {
      if (addCartBtn) addCartBtn.hidden = true;
      nextBtn.hidden = false;
      editBtn.hidden = true;
      clearBtn.hidden = true;
      if (legal) legal.hidden = (stepNum !== 1);
      nextBtn.textContent = (stepNum === maxStep - 1) ? sft('seeResult') : sft('continue');
    }
    var prog = modal.querySelector('[data-meoks-sf-progress] > div');
    if (prog) prog.style.width = ((stepNum / maxStep) * 100) + '%';
    modal.dataset.currentStep = stepNum;
  }

  function readForm(modal) {
    var data = {};
    modal.querySelectorAll('[data-sf-input]').forEach(function (el) {
      var key = el.getAttribute('data-sf-input');
      if (el.tagName === 'SELECT' || el.tagName === 'INPUT') {
        var v = el.value;
        if (key === 'height' || key === 'weight' || key === 'age' || key === 'gogus' || key === 'bel' || key === 'kalca') {
          v = v ? parseInt(v, 10) : null;
        }
        data[key] = v;
      } else if (el.classList.contains('meoks-sf-choices') || el.classList.contains('meoks-sf-radios')) {
        var active = el.querySelector('.is-active') || el.querySelector('input:checked');
        if (active) data[key] = active.getAttribute('data-value') || active.value;
      }
    });
    return data;
  }

  function applyData(modal, data) {
    Object.keys(data || {}).forEach(function (k) {
      var el = modal.querySelector('[data-sf-input="' + k + '"]');
      if (!el) return;
      if (el.tagName === 'SELECT' || el.tagName === 'INPUT') {
        el.value = data[k];
      } else if (el.classList.contains('meoks-sf-choices')) {
        el.querySelectorAll('.meoks-sf-choice').forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-value') === data[k]);
        });
      } else if (el.classList.contains('meoks-sf-radios')) {
        var inp = el.querySelector('input[value="' + data[k] + '"]');
        if (inp) inp.checked = true;
      }
    });
  }

  function showResult(modal, data, recSize) {
    var img = modal.querySelector('[data-sf-result-img]');
    var sizeEl = modal.querySelector('[data-sf-result-size]');
    var grid = modal.querySelector('[data-sf-result-grid]');
    if (img) img.src = modal.getAttribute('data-product-image') || '';
    if (sizeEl) sizeEl.textContent = recSize;
    var rows = [];
    if (data.height) rows.push(['Boy', data.height + ' cm']);
    if (data.kalca_sekli) rows.push([sft('hipLabel'), cap(data.kalca_sekli)]);
    if (data.weight) rows.push(['Kilo', data.weight + ' kg']);
    if (data.fit) rows.push(['Uyum', cap(data.fit)]);
    if (data.karin) rows.push([sft('bellyLabel'), cap(data.karin)]);
    // Dinamik şablon ölçüleri
    var labels = [];
    try { labels = JSON.parse(modal.getAttribute('data-olcu-labels') || '[]'); } catch (e) {}
    for (var i = 1; i <= 6; i++) {
      var val = data['olcu_' + i];
      if (val && val > 0 && labels[i - 1]) rows.push([labels[i - 1], val + ' cm']);
    }
    if (grid) grid.innerHTML = rows.map(function (r) {
      return '<div class="meoks-sf-result__row"><span class="meoks-sf-result__k">' + r[0] + ':</span> <span class="meoks-sf-result__v">' + r[1] + '</span></div>';
    }).join('');
    var addLabel = modal.querySelector('[data-sf-addcart-label]');
    if (addLabel) addLabel.textContent = recSize + ' bedenini sepete ekle';
  }
  function cap(s) { if (!s) return ''; s = s.replace(/-/g, ' '); return s.charAt(0).toUpperCase() + s.slice(1); }

  function placeBadge(recSize) {
    document.querySelectorAll('.meoks-sf-rec-badge').forEach(function (e) { e.remove(); });
    document.querySelectorAll('.product-details .variant-option--buttons label').forEach(function (label) {
      var inp = label.querySelector('input[type="radio"]');
      if (!inp) return;
      if (inp.value === recSize) {
        var badge = document.createElement('span');
        badge.className = 'meoks-sf-rec-badge';
        badge.textContent = 'Tavsiye edilen';
        label.appendChild(badge);
      }
    });
  }

  function bindModal(modal) {
    if (modal.dataset.inited) return;
    modal.dataset.inited = '1';

    // Modal'ı body'ye taşı — parent transform/filter stacking context bypass
    if (modal.parentNode !== document.body) {
      // Eski instance'ları temizle
      document.querySelectorAll('body > [data-meoks-sf-modal]').forEach(function (old) {
        if (old !== modal) old.remove();
      });
      document.body.appendChild(modal);
    }

    document.querySelectorAll('[data-meoks-size-finder-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        modal.hidden = false;
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        document.body.classList.add('meoks-sf-open');
        var stored = load();
        if (stored && stored.size) {
          applyData(modal, stored);
          showResult(modal, stored, stored.size);
          var maxStep = Math.max.apply(null, findStepNumbers(modal));
          setStep(modal, maxStep);
        } else {
          setStep(modal, 1);
        }
      });
    });
    modal.querySelectorAll('[data-meoks-sf-close]').forEach(function (c) {
      c.addEventListener('click', function () { modal.hidden = true; modal.classList.remove('is-open'); document.body.style.overflow = ''; document.body.classList.remove('meoks-sf-open'); });
    });

    // Unit toggles — rebuild dropdown options with correct unit
    function rebuildHeight(unit) {
      var sel = modal.querySelector('[data-sf-input="height"]');
      if (!sel) return;
      var curCm = parseInt(sel.dataset.cmValue, 10) || null;
      var html = '<option value="">' + sft('select') + '</option>';
      if (unit === 'in') {
        // 55in (~140cm) to 83in (~210cm)
        for (var i = 55; i <= 83; i++) {
          var cmEq = Math.round(i * 2.54);
          html += '<option value="' + cmEq + '">' + i + ' IN</option>';
        }
      } else {
        for (var c = 140; c <= 210; c++) {
          html += '<option value="' + c + '">' + c + ' CM</option>';
        }
      }
      sel.innerHTML = html;
      if (curCm) sel.value = unit === 'in' ? Math.round(Math.round(curCm / 2.54) * 2.54) : curCm;
    }
    function rebuildWeight(unit) {
      var sel = modal.querySelector('[data-sf-input="weight"]');
      if (!sel) return;
      var curKg = parseInt(sel.dataset.kgValue, 10) || null;
      var html = '<option value="">' + sft('select') + '</option>';
      if (unit === 'lb') {
        // 77lb (~35kg) to 330lb (~150kg)
        for (var i = 77; i <= 330; i++) {
          var kgEq = Math.round(i * 0.4536);
          html += '<option value="' + kgEq + '">' + i + ' LB</option>';
        }
      } else {
        for (var k = 35; k <= 150; k++) {
          html += '<option value="' + k + '">' + k + ' KG</option>';
        }
      }
      sel.innerHTML = html;
      if (curKg) sel.value = unit === 'lb' ? Math.round(Math.round(curKg / 0.4536) * 0.4536) : curKg;
    }

    modal.querySelectorAll('[data-unit-height]').forEach(function (b) {
      b.addEventListener('click', function () {
        modal.querySelectorAll('[data-unit-height]').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        var sel = modal.querySelector('[data-sf-input="height"]');
        if (sel && sel.value) sel.dataset.cmValue = sel.value;
        rebuildHeight(b.getAttribute('data-unit-height'));
      });
    });
    modal.querySelectorAll('[data-unit-weight]').forEach(function (b) {
      b.addEventListener('click', function () {
        modal.querySelectorAll('[data-unit-weight]').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        var sel = modal.querySelector('[data-sf-input="weight"]');
        if (sel && sel.value) sel.dataset.kgValue = sel.value;
        rebuildWeight(b.getAttribute('data-unit-weight'));
      });
    });
    // Track values for unit conversion
    var hSel = modal.querySelector('[data-sf-input="height"]');
    var wSel = modal.querySelector('[data-sf-input="weight"]');
    if (hSel) hSel.addEventListener('change', function () { hSel.dataset.cmValue = hSel.value; });
    if (wSel) wSel.addEventListener('change', function () { wSel.dataset.kgValue = wSel.value; });

    // Choice buttons (Düz/Orta/Bombeli) — şekil görseli de swap et
    modal.querySelectorAll('.meoks-sf-choices').forEach(function (group) {
      var key = group.getAttribute('data-sf-input');
      group.querySelectorAll('.meoks-sf-choice').forEach(function (c) {
        c.addEventListener('click', function () {
          group.querySelectorAll('.meoks-sf-choice').forEach(function (x) { x.classList.remove('is-active'); });
          c.classList.add('is-active');
          var val = c.getAttribute('data-value');
          var img = modal.querySelector('.meoks-sf-shape__img[data-sf-shape-img="' + key + '"]');
          if (img) {
            var newSrc = img.getAttribute('data-img-' + val);
            if (newSrc) img.src = newSrc;
          }
        });
      });
    });

    var stepArr = findStepNumbers(modal);
    var maxStep = Math.max.apply(null, stepArr);

    // Next
    modal.querySelector('[data-sf-next]').addEventListener('click', function () {
      var cur = parseInt(modal.dataset.currentStep || '1', 10);
      var nextIdx = stepArr.indexOf(cur) + 1;
      if (nextIdx >= stepArr.length) return;
      var nextStep = stepArr[nextIdx];
      if (nextStep === maxStep) {
        var data = readForm(modal);
        if (!data.height || !data.weight) { alert(sft('selectHeightWeightAlert')); setStep(modal, 1); return; }
        var rec = calcRecommendation(modal, data);
        data.size = rec;
        save(data);
        showResult(modal, data, rec);
        placeBadge(rec);
      }
      setStep(modal, nextStep);
    });

    // Back
    modal.querySelector('[data-meoks-sf-back]').addEventListener('click', function () {
      var cur = parseInt(modal.dataset.currentStep || '1', 10);
      var prevIdx = stepArr.indexOf(cur) - 1;
      if (prevIdx < 0) return;
      setStep(modal, stepArr[prevIdx]);
    });

    // Add to cart from result step
    modal.querySelector('[data-sf-addcart]').addEventListener('click', function () {
      var stored = load();
      if (!stored || !stored.size) return;
      // Önce beden butonunu seç (varsa)
      var sizeRadio = null;
      document.querySelectorAll('.product-details .variant-option--buttons input[type="radio"]').forEach(function (inp) {
        if (inp.value === stored.size && !inp.disabled && inp.getAttribute('aria-disabled') !== 'true') {
          sizeRadio = inp;
        }
      });
      if (!sizeRadio) {
        alert(sft('sizeOutOfStockAlert', {S: stored.size}));
        return;
      }
      sizeRadio.click();
      // Kısa bekleme + add-to-cart butonuna tıkla
      setTimeout(function () {
        var addBtn = document.querySelector('.product-details .add-to-cart-button:not(.meoks-similar-cta)');
        if (!addBtn) addBtn = document.querySelector('.product-details button[name="add"]');
        if (addBtn) {
          addBtn.click();
          // Modal'ı kapat
          modal.hidden = true;
          modal.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      }, 200);
    });

    // Edit (resultstep)
    modal.querySelector('[data-sf-edit]').addEventListener('click', function () { setStep(modal, 1); });
    // Clear
    modal.querySelector('[data-sf-clear]').addEventListener('click', function () {
      clear();
      document.querySelectorAll('.meoks-sf-rec-badge').forEach(function (e) { e.remove(); });
      setStep(modal, 1);
      modal.querySelectorAll('select').forEach(function (s) { s.value = ''; });
    });

    setStep(modal, 1);

    // Auto-apply badge on page load if data exists
    var stored = load();
    if (stored && stored.size) placeBadge(stored.size);
  }

  function init() { document.querySelectorAll('[data-meoks-sf-modal]').forEach(bindModal); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  var __p = false;
  new MutationObserver(function () {
    if (__p) return; __p = true;
    (window.requestIdleCallback || window.requestAnimationFrame)(function () { __p = false; init(); });
  }).observe(document.body, { childList: true, subtree: true });
})();
